import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import * as Models from 'models';
import { HISTORY_TAGS } from '../HistoryWithExtraStatePlugin';
import { $applyBrandStyleForTextBlock } from './brandStyle';
import { registerEditorPropsCommands } from './commands';
import { TextBlockProps } from './types';
import { $getHorizontalAlignmentBlockTypeFromSelection } from './utils/horizontal-alignment';
import { $getBlockLineHeightFromSelection } from './utils/line-height';

export type { TextBlockProps } from './types';
export { TEXT_BLOCK_COMMAND } from './commands';

type Props = {
  onChange: (props: TextBlockProps) => void;
  brandStyle?: Models.BrandStyleMap;
  brandStyleChanged?: boolean;
  editorState: string;
};

export function TextBlockPlugin(props: Props): null {
  const { onChange, brandStyle, brandStyleChanged, editorState } = props;

  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return registerEditorPropsCommands(editor);
  }, [editor]);

  useEffect(() => {
    editor.update(() => {
      if (brandStyleChanged) {
        return;
      }
      $applyBrandStyleForTextBlock(brandStyle);
    }, { tag: HISTORY_TAGS.MERGE, discrete: true });
  }, [editor, brandStyle, brandStyleChanged, editorState]);

  useEffect(() => {
    const readEditorStateAndNotifyChange = (): void => {
      const values = {
        blockLineHeight: $getBlockLineHeightFromSelection(),
        blockType: $getHorizontalAlignmentBlockTypeFromSelection(),
      };
      onChange(values);
    };

    editor.getEditorState().read(readEditorStateAndNotifyChange);

    return editor.registerUpdateListener(({ editorState: state }) => {
      state.read(readEditorStateAndNotifyChange);
    });
  }, [editor, onChange]);

  return null;
}
